/* wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3ickbl%7Bheight%3A3pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1ylp%7Bheight%3A40px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3izwfg%7Bheight%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1tcg%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3igktf%7Bheight%3A20px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i7vkz%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vc881r31%20stop%7Bstop-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3se11kw7%20%3Esvg%7Bfill%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zbji1osq%20%3Esvg%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._o5724jg8%7Bwhite-space%3Anormal%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._uiztglyw%7B-webkit-user-select%3Anone%3B-moz-user-select%3Anone%3Buser-select%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vwz4kb7n%7Bline-height%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._lswu1xf6%7Bfill%3Avar(--logo-fill)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1vry%7Bcolor%3Avar(--logo-color)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswh2mm%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1o8l%7Bdisplay%3Ainline-block%7D");
import { type WrapperProps } from './constants';
const CSS_VAR_COLOR = '--logo-color';
const CSS_VAR_FILL = '--logo-fill';
const styles = {
  root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
  stop: "_vc881r31",
  xxsmall: "_4t3i7vkz",
  xsmall: "_4t3igktf",
  small: "_4t3i1tcg",
  medium: "_4t3izwfg",
  large: "_4t3i1ylp",
  xlarge: "_4t3ickbl"
};

/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */
const Wrapper = ({
  label,
  svg,
  size,
  appearance,
  iconColor,
  textColor,
  testId: userDefinedTestId,
  ...rest
}: WrapperProps): JSX.Element => {
  // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
  const shouldApplyStopColor = appearance === undefined;
  const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
  return <span data-testid={testId} style={({
    [CSS_VAR_COLOR]: iconColor,
    [CSS_VAR_FILL]: textColor
  } as React.CSSProperties)} aria-label={label ? label : undefined} role={label ? 'img' : undefined} dangerouslySetInnerHTML={{
    __html: svg
  }}
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  {...rest} className={ax([styles.root, shouldApplyStopColor && styles.stop, size && styles[size]])} />;
};
export default Wrapper;